import {
  IHistoryItemData,
  IRawStoredDataRes,
  TInquiriesKey,
  TVariantType,
} from "@/interfaces";
import { cn, toJalali } from "@/lib";

import {
  BdBillList,
  BdCardSearch,
  BdGlobus,
  BdPlate,
  BdScale,
  BdWadOfMoney,
} from "solar-icon-react/bd";
import { JSX } from "react";

const baseIconStyles = {};

const CATEGORY_MAP: Record<
  TInquiriesKey,
  { variant: TVariantType; icon: JSX.Element }
> = {
  "1": {
    variant: "emerald-mint",
    icon: (
      <BdCardSearch
        {...baseIconStyles}
        className={cn("text-emerald-mint! size-full!")}
      />
    ),
  },
  "2": {
    variant: "sky-bliss",
    icon: (
      <BdPlate
        {...baseIconStyles}
        className={cn("text-sky-bliss! size-full!")}
      />
    ),
  },
  "3": {
    variant: "teal-ocean",
    icon: (
      <BdGlobus
        {...baseIconStyles}
        className={cn("text-teal-ocean! size-full!")}
      />
    ),
  },
  "4": {
    variant: "sunset-gold",
    icon: (
      <BdScale
        {...baseIconStyles}
        className={cn("text-sunset-gold! size-full!")}
      />
    ),
  },
  // "5": {
  //   variant: "yellow-500",
  //   icon: (
  //     <BdVerifiedCheck
  //       {...baseIconStyles}
  //       className={cn("text-yellow-500! size-full!")}
  //     />
  //   ),
  // },
  "6": {
    variant: "rose-500",
    icon: (
      <BdBillList
        {...baseIconStyles}
        className={cn("size-full! text-rose-500!")}
      />
    ),
  },
  "7": {
    variant: "yellow-500",
    icon: (
      <BdWadOfMoney
        {...baseIconStyles}
        className={cn("size-full! text-yellow-500!")}
      />
    ),
  },
};
const billIds = [67, 69, 68, 70, 74];
const billType = {
  now: "میان دوره",
  normal: "پایان دوره",
};
export const getStoredDataAdapter = (
  data: IRawStoredDataRes,
): IHistoryItemData[] => {
  return data?.map(
    ({
      id,
      inquery_id,
      created_at,
      status,
      code,
      inquery,
      data: responseData,
    }) => {
      const categoryKey = (inquery?.category_id as TInquiriesKey) || "1";
      const { variant, icon } = CATEGORY_MAP[categoryKey] || CATEGORY_MAP["1"];

      const input = responseData?.input ? { ...responseData.input } : undefined;

      const message = responseData?.message;
      const success = responseData?.success;
      const mainData = responseData?.data;
      if (inquery?.flag === "returned_check" && input) {
        input.customer_type = input.customer_type === "1" ? "حقوقی" : "حقیقی";
      }
      const findBill = billIds.find((b) => inquery_id === b);
      if (findBill && input) {
        input.type = billType[input.type as keyof typeof billType];
      }
      const vehicleReportInput =
        String(inquery?.flag) === "vehicle_comprehensive_report" && input
        ? [
            input.national_code ? `کد ملی: ${input.national_code}` : null,
            [input.plk1, input.plk2, input.plk3, input.plk_serial].every(Boolean)
              ? `پلاک: ${input.plk1} ${input.plk2} ${input.plk3} ایران ${input.plk_serial}`
              : null,
          ].filter(Boolean).join(" • ")
        : null;

      let responseMessage =
        typeof message === "string"
          ? message
          : message?.data?.message
            ? message.data?.message
            : null;
      // if (
      //   inquery?.flag === "validate" ||
      //   (mainData && !mainData?.customerInfo)
      // ) {
      //   status = "failed";
      //   responseMessage = "خطا در اطلاعات ارسالی";
      // }

      if (!mainData) {
        responseMessage = "منقضی شده";
      }
      return {
        id,
        title: inquery?.name,
        date: toJalali(created_at),
        inquiryId: inquery_id,
        categoryIcon: icon,
        variant,
        flag: inquery?.flag || "",
        code,
        status: !(status === "failed" || !success),
        message: responseMessage,
        input: vehicleReportInput ?? (input ? Object.values(input).join(" - ") : ""),
        hasData: !!responseData,
      };
    },
  );
};
